/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum InvalidAudioChannelType {
    AudioInputChannel = 0,
    VogAudioOutputChannel = 1,
    VopAudioOutputChannel = 2,
    VttAudioOutputChannel = 3,
}
